<template>
  <section class="layout-grid-block">
    <div class="layout-grid-block__grid" :style="gridStyle">
      <div
        v-for="(cell, idx) in cells"
        :key="idx"
        class="layout-grid-block__cell"
        :style="cellStyle(cell)"
      >
        <AppLayoutNestedContent :blocks="cell.blocks || []" />
      </div>
    </div>
  </section>
</template>

<script>
import AppLayoutNestedContent from '@/components/Blocks/AppLayoutNestedContent.vue'

export default {
  name: 'AppLayoutGridBlock',
  components: { AppLayoutNestedContent },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    rows() {
      return Math.min(4, Math.max(1, Number(this.data && this.data.rows) || 2))
    },
    cols() {
      return Math.min(4, Math.max(1, Number(this.data && this.data.cols) || 2))
    },
    gap() {
      return (this.data && this.data.gap) || '16px'
    },
    cells() {
      return (this.data && this.data.cells) || []
    },
    gridStyle() {
      return {
        display: 'grid',
        gap: this.gap,
        gridTemplateColumns: `repeat(${this.cols}, minmax(0, 1fr))`,
        gridTemplateRows: `repeat(${this.rows}, minmax(80px, auto))`,
      }
    },
  },
  methods: {
    cellStyle(cell) {
      const row = Number(cell.row) || 0
      const col = Number(cell.col) || 0
      const rowSpan = Math.max(1, Number(cell.rowSpan) || 1)
      const colSpan = Math.max(1, Number(cell.colSpan) || 1)
      return {
        gridRow: `${row + 1} / span ${rowSpan}`,
        gridColumn: `${col + 1} / span ${colSpan}`,
      }
    },
  },
}
</script>

<style scoped lang="scss">
.layout-grid-block {
  padding: 24px 0;

  &__grid {
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 20px;
  }

  &__cell {
    min-width: 0;
  }

  @media (max-width: 768px) {
    &__grid {
      display: flex !important;
      flex-direction: column;
    }

    &__cell {
      grid-row: auto !important;
      grid-column: auto !important;
    }
  }
}
</style>
